import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { ClockIcon } from 'src/shared/components';
import { DATE_TIME_FORMAT } from 'src/shared/constants';
import { useTranslate } from 'src/shared/providers';
import { formatTime } from 'src/shared/utils';
import { getTimeFormat } from 'src/store/user/user.selectors';

interface Props {
  startTime: string;
  endTime: string;
}

export const CalendarTimeInfo: FC<Props> = ({ startTime, endTime }) => {
  const { t } = useTranslate();
  const timeFormat = useSelector(getTimeFormat);

  const formattedStartTime = startTime ? formatTime(startTime, timeFormat, DATE_TIME_FORMAT) : undefined;
  const formattedEndTime = endTime ? formatTime(endTime, timeFormat, DATE_TIME_FORMAT) : undefined;

  return (
    <div className="d-flex align-items-center mb-3">
      <ClockIcon color="#6C757D" size={20} className="me-2" />
      <span className="fw-500 me-1">
        {t('global.start')} - {t('global.end')}:
      </span>
      {formattedStartTime} - {formattedEndTime}
    </div>
  );
};
